export default __webpack_public_path__ + "static/media/1116.064c0727.png";